<template>
<div class='b-route-wrapper'>
    <Teleport to='body'>
        <div id='popupWrapper'></div>
    </Teleport>
    <FixedBackground></FixedBackground>
    <div class='b-main-panel-wrapper'>
        <AppHeader v-if='showAppHeader'></AppHeader>
        <div class='h-pos-rel container h-width-100p'>
            <GoBackButton
                v-if='showBackButton'
                class='b-route-wrapper__back_arrow'>
            </GoBackButton>
        </div>
        <router-view></router-view>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-facing-decorator';

import { AppHeader } from '@/components/global/AppHeader';
import { GoBackButton } from '@/components/simple/GoBackButton';
import { FixedBackground } from '../FixedBackground';

@Component({
    components: {
        GoBackButton,
        FixedBackground,
        AppHeader,
    },
})
export default class RouterWrapper extends Vue {
    get showAppHeader(): boolean {
        // @ts-ignore-next-line
        return !(this.$route.meta && this.$route.meta.hideHeader);
    }
    get showBackButton(): boolean {
        // @ts-ignore-next-line
        return !!(this.$route.meta && this.$route.meta.backButton);
    }
}
</script>

<style lang='sass'>
.b-route-wrapper
    width: 100%
    min-height: 100vh
    position: relative
    display: flex
    height: 100%

    &__back_arrow
        left: 100px
        top: 62px

.b-main-panel-wrapper
    width: 100%
    display: flex
    flex-direction: column

@include media('<desktop')
    .b-route-wrapper
        &__back_arrow
            margin-left: 10px
            margin-top: 20px
            position: static
</style>
